module.exports = __webpack_public_path__ + "media/coffee-preferences/country_of_origin_colombia-d67ebcb4.png";